import L from "leaflet";
import { Marker } from "react-leaflet";
import { VehicleGeolocated } from "./index";
import { VehicleDot } from "@qivia/ui/src/assets/assets";
import { useMemo, useCallback } from "react";
import ReactDOMServer from "react-dom/server";
import { getDataPointsByVehicleAndDateAsync } from "./geolocationSlice";
import { useAppDispatch } from "../../../redux/hooks";
import { TooltipVehicleTrip } from "./tooltipVehicleTrip";

export const VehiclesShowOnMap = (props: {
  handleSelectVehicle: (vehicle: VehicleGeolocated) => void;
  hoveredVehicleId: string | null;
  setShowTripForVehicleUuid: (vehicleUuid: string) => void;
  vehiclesToDisplay: VehicleGeolocated[];
  date: Date;
}) => {
  const dispatch = useAppDispatch();
  const {
    handleSelectVehicle,
    hoveredVehicleId,
    setShowTripForVehicleUuid,
    vehiclesToDisplay,
    date,
  } = props;

  const vehiclesToShowOnMap = useMemo(
    () =>
      hoveredVehicleId
        ? vehiclesToDisplay.filter((v) => v.uuid === hoveredVehicleId)
        : vehiclesToDisplay,
    [hoveredVehicleId, vehiclesToDisplay],
  );

  const onClickVehicleOnMap = useCallback(
    (vehicle: VehicleGeolocated) => {
      //TODO LATER IF WE WANT
      // handleSelectVehicle(vehicle);
      if (!vehicle.dataPoints) {
        void dispatch(
          getDataPointsByVehicleAndDateAsync({
            vehicleUuid: vehicle.uuid,
            date: date.toISOString(),
          }),
        );
      }
      setShowTripForVehicleUuid(vehicle.uuid);
    },
    [date, dispatch, setShowTripForVehicleUuid],
  );

  return (
    <>
      {vehiclesToShowOnMap.map((v) => (
        <Marker
          position={[v.lastLatitude || 0, v.lastLongitude || 0]}
          key={v.uuid}
          icon={vehicleOnIcon}
          eventHandlers={{
            click: () => onClickVehicleOnMap(v),
          }}
        >
          <TooltipVehicleTrip
            vehicle={v}
            handleSelectVehicle={handleSelectVehicle}
          />
        </Marker>
      ))}
    </>
  );
};

const vehicleOnIcon = L.divIcon({
  className: "custom-vehicle-on-icon",
  html: ReactDOMServer.renderToString(<VehicleDot />),
  iconSize: [24, 24],
  iconAnchor: [12, 16],
});
